import PropTypes from "prop-types";
import { useEffect, useState } from "react";

//Libraries
import { v4 as uuidv4 } from "uuid";
import clsx from "clsx";

// MUI
import { Collapse, Divider, Grid, Skeleton, Stack, Typography } from "@mui/material";

// Icons
import SearchInput from "@/Layouts/components/Tables/DataSmartTable/toolbar/SearchToolbar/SearchInput";

//Layouts
import ActionCard from "@/Layouts/components/Cards/ActionCard/ActionCard";
import { CollapsibleSection } from "@/Layouts/components/SectionContainer/sections";

export default function CurrentAssignmentFilter(props) {
	const { sxSearchText = null, usersByCurrentPayPlanLoading = false, isLoading = false, areaOpen = false } = props;

	const [assignment, setAssignment] = useState([]);
	const [value, setValue] = useState("");

	const handleInputSearch = (event) => {
		setValue(event.target.value);
	};

	const [collapsed, setCollapsed] = useState(false);

	const handleExpandToggle = () => {
		setCollapsed(!collapsed);
	};

	useEffect(() => {
		if (props.employeesCurrentAssignment) {
			setAssignment(props.employeesCurrentAssignment);
		}
	}, [props]);

	const filteredAssignment = assignment?.filter((element) => element?.fullName?.toLowerCase().includes(value.toLowerCase()));

	return (
		<Collapse className="general-section-container" in={!collapsed} collapsedSize={40} timeout={100}>
			<Grid item className="!w-auto !m-h-[60px] !mb-[20px]">
				<Grid
					container
					direction="row"
					alignItems="center"
					justifyContent={"space-between"}
					className="select-plan-dialog-current-assign-container"
				>
					<Grid item>
						<Stack direction={"row"} alignItems={"center"}>
							<Typography className="select-plan-dialog-current-assign-title" paddingBottom={0.5}>
								Current Assignments
							</Typography>
							<CollapsibleSection collapsed={collapsed} loading={false} handleExpandToggle={handleExpandToggle} />
						</Stack>
					</Grid>

					<Grid item>
						<Stack direction={"row"}>
							<SearchInput
								value={value}
								sx={sxSearchText}
								onChange={handleInputSearch}
								onClear={() => {
									setValue("");
								}}
							/>
						</Stack>
					</Grid>
				</Grid>
				<Grid
					container
					sx={{ overflow: "hidden", maxHeight: open || areaOpen ? "none" : "30px" }}
					className="!h-[145px] !overflow-y-auto"
				>
					{usersByCurrentPayPlanLoading || isLoading ? (
						<>
							{Array.from({ length: 3 }).map(() => (
								<Grid item xs={4} key={uuidv4()}>
									{Array.from({ length: 3 }).map(() => (
										<Skeleton
											key={uuidv4()}
											variant="rectangular"
											width={226}
											height={34}
											className="!rounded-[6px] !my-[10px] !mx-[8px]"
										/>
									))}
								</Grid>
							))}
						</>
					) : (
						<>
							{filteredAssignment?.map((element) => (
								<Grid item key={uuidv4()} xs={4}>
									<ActionCard
										classes={clsx({
											"[&_.MuiCardHeader-title]:!font-sans": true,
											"[&_.MuiCardHeader-title]:!font-bold": true,
											"[&_.MuiCardHeader-title]:!text-default": true,
											"[&_.MuiCardHeader-title]:!text-[14.5]": true,
											"[&_.MuiCardHeader-root]:!py-[6px]": true,
											"[&_.MuiCardHeader-root]:!px-[8px]": true,
											"[&_.MuiCardHeader-root]:!!truncate": true,
											"m-2 !rounded-[6px]": true,
											"!shadow-[0_2px_8px_0_#00000040]": true,
										})}
										title={element?.fullName}
									/>
								</Grid>
							))}

							{!filteredAssignment?.length && (
								<Grid item xs={3}>
									<Typography
										sx={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}
										className="!font-sans !text-[16px] !text-default !ml-[20px] !mr-[5px]"
									>
										{"No current assignments"}
									</Typography>
								</Grid>
							)}
						</>
					)}
				</Grid>

				<Divider className="w-full !mt-[16px]" />
			</Grid>
		</Collapse>
	);
}
CurrentAssignmentFilter.propTypes = {
	employeesCurrentAssignment: PropTypes.array,
	sxSearchText: PropTypes.object,
	usersByCurrentPayPlanLoading: PropTypes.bool,
	isLoading: PropTypes.bool,
	areaOpen: PropTypes.bool,
};
